import binaryChecker from '@/file/binary-checker';
import FileItem from '@/file/file-item';
import IgnoreFile from '@/file/ignore-file';
import blobFileItemReader from '@/file/blob-file-item-reader';
import generic from './scaffold-extractor';

export default class ScaffoldFolderExtractor {
  static extract(rawFiles, consumption) {
    return generic.unusedPrefix(this.paths(rawFiles)).then((unusedPrefix) => {
      return this.nonIgnoredPaths(rawFiles, unusedPrefix).then((paths) => {
        return this.extractBlobAndRenameFiles(rawFiles, paths, unusedPrefix).then((files) => {
          return generic.validateSize(files, consumption).then(() => (
            generic.validateConfigFiles(files)
          ));
        });
      });
    });
  }

  static extractBlobAndRenameFiles(rawFiles, paths, unusedPrefix) {
    return new Promise((resolve, reject) => {
      try {
        const adjustedFiles = [];
        for (let i = 0; i < rawFiles.length; i++) {
          const f = rawFiles[i];
          const isNotIgnored = paths.some(path => path === f.webkitRelativePath);
          if (isNotIgnored) {
            const file = new FileItem(generic
              .removeUnusedPrefix(
                f.webkitRelativePath,
                unusedPrefix,
              ));
            file.blob = f;
            file.binary = binaryChecker.isBinary(file);
            adjustedFiles.push(file);
          }
        }
        resolve(adjustedFiles);
      } catch (error) {
        reject(error);
      }
    });
  }

  static nonIgnoredPaths(rawFiles, unusedPrefix) {
    return this.buildIgnoreFile(rawFiles).then((ignoreFile) => {
      const paths = [];
      for (let i = 0; i < rawFiles.length; i++) {
        const path = rawFiles[i].webkitRelativePath;
        if (!generic.isToIgnore(path, false, unusedPrefix, ignoreFile)) {
          paths.push(path);
        }
      }
      return paths;
    });
  }

  static buildIgnoreFile(rawFiles) {
    return new Promise((resolve) => {
      for (let i = 0; i < rawFiles.length; i++) {
        const file = rawFiles[i];
        if (file.webkitRelativePath.endsWith('scaffoldhub/ignore.txt')) {
          const fileItem = new FileItem();
          fileItem.blob = file;
          blobFileItemReader.read(fileItem).then((fileWithContent) => {
            resolve(new IgnoreFile(fileWithContent.content));
          });
          return;
        }
      }
      resolve(null);
    });
  }

  static paths(rawFiles) {
    const paths = [];

    for (let i = 0; i < rawFiles.length; i++) {
      paths.push(rawFiles[i].webkitRelativePath);
    }

    return paths;
  }
}
